import { TextOutlineIcon } from '@carboncopyco/icons';
import type { IDynamicEditData } from '@carboncopyco/types';
import { ModificationItem } from './ModificationItem';

export const TextModificationItem = ({
  edit,
  editTextOld,
  setEditTextOld,
  errorMessageOld,
  editTextNew,
  setEditTextNew,
  errorMessageNew,
  isEditMode,
  setIsEditMode,
}: {
  edit:
    | IDynamicEditData['element']
    | { old: { value: string }; new: { value: string } };
  editTextOld?: string;
  setEditTextOld?: (value: string) => void;
  errorMessageOld?: string;
  editTextNew?: string;
  setEditTextNew?: (value: string) => void;
  errorMessageNew?: string;
  isEditMode?: boolean;
  setIsEditMode?: { set: (value: boolean) => void };
}) => {
  return (
    <ModificationItem>
      <ModificationItem.Content>
        <ModificationItem.Icon>
          <TextOutlineIcon size={18} />
        </ModificationItem.Icon>
        <ModificationItem.Text
          label={edit.old.value}
          isEdit={isEditMode}
          editText={editTextOld}
          setEditText={setEditTextOld}
          errorMessage={errorMessageOld}
          setEditMode={setIsEditMode?.set}
        />
      </ModificationItem.Content>
      <ModificationItem.Arrow />
      <ModificationItem.Content>
        <ModificationItem.Text
          label={edit.new.value}
          isEdit={isEditMode}
          setEditText={setEditTextNew}
          editText={editTextNew}
          errorMessage={errorMessageNew}
          setEditMode={setIsEditMode?.set}
        />
      </ModificationItem.Content>
    </ModificationItem>
  );
};
